import styled from 'styled-components'

import { backgroundTypes, borderTypes, boxModelTypes, cssTypes } from '../types'
import { background, border, boxModel, css } from '../util'

/**
 * @namespace Image
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Image = styled.div`
  ${background};
  ${border};
  ${boxModel};
  ${css};
  background-image: url(${({ src }) => src});
`

/**
 * @name defaultProps
 * @memberof Image
 * @desc Primitive's default properties
 */
Image.defaultProps = {
  backgroundRepeat: 'no-repeat',
  borderWidth: [0],
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Image
 * @desc Primitive's prop type definitions
 */
Image.propTypes = {
  ...backgroundTypes,
  ...borderTypes,
  ...boxModelTypes,
  ...cssTypes,
}

/** @component */
export default Image
